<router-outlet></router-outlet>
<footer>
  <a routerLink="/cookies-policy" style="cursor: pointer">Polityka Cookies</a>
  <!-- OneTrust Cookies Settings button start -->
  <a class="optanon-toggle-display" style="cursor: pointer"
    >Ustawienia Cookies</a
  >
  <!-- OneTrust Cookies Settings button end -->

  <a routerLink="/privacy-policy" style="cursor: pointer"
    >Polityka Prywatności</a
  >
</footer>
